import IconRejected from "@components/Images/IconRejected";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import CustomRightImage from "@components/CustomRightImagev2";

const LigaCaducada = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={8}>
        <Box>
          <Typography
            variant={isMobileOrTablet ? "h4" : "h3"}
            color={theme?.palette?.primary?.dark}
            fontWeight={700}
            align="center"
          >
            Liga de Ingreso de Aval Caducada
          </Typography>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.main}
            align="center"
            mt={4}
          >
            Lo sentimos mucho, lamentamos <br /> informarte que la siguiente liga ha caducado
          </Typography>

          <Box display="flex" justifyContent="center" mt={4}>
            <IconRejected width={isMobileOrTablet ? "110" : "170"} fill={theme.palette.primary.main} />
          </Box>

          <Typography
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.dark}
            align="center"
            mt={4}
          >
            Para mayor información, contacta a tu asesor
          </Typography>
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default LigaCaducada;
